import React, { useRef, useState } from 'react';

import {
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import {
  FileCopyOutlined as CopyIcon,
  Check as CheckIcon,
} from '@material-ui/icons';

import { copyToClipboard } from '../../helpers';

const useStyles = makeStyles((theme) => ({
  copyBox: {
    display: 'flex',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),

    '& .MuiInputBase-input:not(.form-control)': {
      fontSize: 12,
      color: theme.palette.text.primary,
      padding: theme.spacing(2, 1),
      textAlign: 'center',
    },

    '& .MuiInput-underline': {
      '&::after': {
        borderBottom: 0,
      },

      '&:not(.Mui-disabled)::before': {
        borderBottom: `2px dotted ${theme.palette.text.secondary}`,
      },
    },
  },
}));

export default function CopyToClipboard({ text, ...props }) {
  const classes = useStyles();
  const inputRef = useRef(null);
  const [copiedToClipboard, setCopiedToClipboard] = useState(false);

  const handleCopyToClipboard = () => {
    copyToClipboard(inputRef.current.querySelector('input'));
    setCopiedToClipboard(true);

    setTimeout(() => {
      setCopiedToClipboard(false);
    }, 3000);
  };

  return (
    <TextField
      InputProps={{
        readOnly: true,
        endAdornment: (
          <InputAdornment position="end">
            <Tooltip title="Copied to clipboard" open={copiedToClipboard}>
              <IconButton onClick={handleCopyToClipboard}>
                {copiedToClipboard ? <CheckIcon /> : <CopyIcon />}
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
      }}
      className={classes.copyBox}
      defaultValue={text}
      ref={inputRef}
      type="text"
      {...props}
    />
  );
}
